import api from "./api";


export const createSubnet = async (subnetData, schemaName = null) => {
    try {
      const response = await api.post("/subnets/", subnetData, {
        params: schemaName ? { client: schemaName } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error creating subnet:", error);
      throw error;
    }
};



export const getAllSubnets = async (schemaName = null) => {
    try {
      const response = await api.get("/subnets/", {
        params: schemaName ? { client: schemaName } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching vlans:", error);
      throw error;
    }
};


export const updateSubnet = async (id,subnetData, schemaName = null) => {
  try {
    const response = await api.put(`/subnets/${id}/`, subnetData, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating vlan:", error);
    throw error;
  }
};


export const deleteSubnet = async (id, schemaName = null) => {
  try {
    // axios.delete signature is (url, config); the params config must be the
    // second argument. The schema is sent as ?client= so staff/SP deletes
    // resolve the tenant (the backend reads client from the query on DELETE).
    const response = await api.delete(`/subnets/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting subnet:", error);
    throw error;
  }
};